/*LIBRARY*/
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { ArrowBack } from "@material-ui/icons";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import Tabs from "../reuseable/Tabs";
import PaymentTable from "./PaymentTable";
import RedeemButton from "./RedeemButton";
import PaymentInstruction from "../../Pages/dashboard/PaymentInstruction";
import WaitForTransactionProcess from "./WaitForTransactionProcess";
import ErrorPayment from "./ErrorPayment";
import PaymentMethod from "./PaymentMethod";

/*REDUX*/
import { set_value_user } from "../../App/actions/authActions";
import { set_value_payment } from "../../App/actions/paymentActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const menu_tabs = ["license", "redeem code"];

const Pricing = ({ from, is_redirect = false, create_payment }) => {
  const [package_selected, set_package_selected] = useState("personal");
  const [actived_tab, set_actived_tab] = useState("license");
  const [page, set_page_state] = useState("packages"); // packages, payment, loading
  const [package_object, set_package_object] = useState({});
  const [payment_id, set_payment_id] = useState("");
  const [error, set_error] = useState({});
  const [month] = useState(undefined);

  /* REDUX AND ROUTER DECLARATIONS ADDED HERE */
  const dispatch = useDispatch();
  const location = useLocation();

  const auth = useSelector((state) => state.auth);
  const payment_reducer = useSelector((state) => state.payment);

  const { user, modal_payment_universal } = auth || {};
  const path_wo_payment_popup = ["/login", "/register"];

  /* TOGGLE FUNCTION MIGRATED FROM NAVIGATION */
  const toggle_payment_universal = () => {
    const { payment, is_able_to_greeting_page } = payment_reducer || {};
    const { is_sandbox, status } = payment || {};

    const user_type =
      sessionStorage.getItem("user_type") || "user_personal_license";
    let path = "";
    if (user_type === "user_personal_license") {
      path = "personal_license";
    } else if (user_type === "user_business") {
      path = "personal_license_business";
    }

    sessionStorage.removeItem("user_type");

    if (
      modal_payment_universal &&
      status === "success" &&
      is_able_to_greeting_page
    ) {
      let url = is_sandbox
        ? `https://staging.mapid.co.id/greetings`
        : `https://mapid.co.id/greetings`;
      url += `/${path}`;
      window.open(url, "_blank");
    }

    dispatch(
      set_value_user("modal_payment_universal", !modal_payment_universal),
    );
    dispatch(
      set_value_payment({ key: "is_able_to_greeting_page", value: false }),
    );

    set_page_state("packages");
  };

  const set_page = useCallback(
    ({ package_object: new_package_object, new_page }) => {
      const list_of_pages = [
        "packages",
        "payment_method",
        "payment",
        "loading",
        "error",
      ];

      if (new_page && list_of_pages.includes(new_page)) {
        set_page_state(new_page);
      }
      if (new_package_object) {
        set_package_object(new_package_object);
      }
    },
    [],
  );

  useEffect(() => {
    const process_payment = async () => {
      const payment = localStorage.getItem("payment");

      if (payment && payment !== "") {
        const body = {
          payment_type: "license_1",
          month: parseInt(payment), // ✅ Diberi key yang benar
          payment_methode: "midtrans",
        };

        let response = "";
        const current_url = window.location.href;
        if (current_url.includes("user_profile")) {
          response = await create_payment(body, "user_profile");
        } else {
          response = await create_payment(body);
        }

        if (response?.status === 200 && response?.id) {
          set_payment_id(response.id);
          set_page({ new_page: "payment" });
        } else {
          set_page({ new_page: "error" });
          set_error(response);
        }
      }
    };

    process_payment();
  }, [create_payment, set_page]);

  // on_set_month = (month) => {
  //   this.setState({ month });
  // };

  // on_set_collaborators = (collaborators) => {
  //   this.setState({ collaborators });
  // };

  const handle_tab = (value) => {
    set_actived_tab(value);
  };

  // local storage
  const language = localStorage?.language || "ina";

  let content, title, description;
  if (actived_tab === "license") {
    if (page === "packages") {
      title = dict?.["Find the Perfect Plan for Your Business"]?.[language];
      description =
        dict?.[
          "Get features at the best price on the market! Limited timeoffer to boost your productivity."
        ]?.[language];
      content = (
        <PaymentTable
          set_package_selected={set_package_selected}
          package_selected={package_selected}
          month={month}
          // on_set_month={this.on_set_month}
          // on_set_collaborators={this.on_set_collaborators}
          page={page}
          set_page={set_page}
        />
      );
    } else if (page === "payment_method") {
      title = "metode pembayaran"; //dict?.["Payment"]?.[language];
      // description = dict?.["Get features at the best price on the market! Limited timeoffer to boost your productivity."]?.[language]

      content = (
        <PaymentMethod
          set_page={set_page}
          month={month}
          set_payment_id={set_payment_id}
          package_object={package_object}
          set_error={set_error}
        />
      );
    } else if (page === "payment") {
      title = dict?.["Payment"]?.[language];
      // description = dict?.["Get features at the best price on the market! Limited time offer to boost your productivity."]?.[language]

      content = (
        <PaymentInstruction
          is_redirect={is_redirect}
          payment_id={payment_id || ""}
        />
      );
    } else if (page === "loading") {
      title = dict?.["Please Wait..."]?.[language];
      content = <WaitForTransactionProcess />;
    } else if (page === "error") {
      title = dict?.["Error"]?.[language];
      content = <ErrorPayment error={error} />;
    }
  } else if (actived_tab === "redeem code") {
    title = "Redeem MAPID Code";
    description = dict?.["Enter your code to get discount."]?.[language];
    content = <RedeemButton />;
  }

  const inside_content = (
    <main className="flex flex_col gap_30">
      <header className="flex justify_start gap_20">
        {page !== "packages" && (
          <div className="flex justify_start">
            <div
              onClick={() => {
                if (
                  page === "payment_method" ||
                  page === "payment" ||
                  page === "error"
                ) {
                  set_page({ new_page: "packages" });
                }
              }}
              className="pointer hover_bigger w_50 h_50 background_black center_perfect text_white rounded_50"
            >
              <ArrowBack />
            </div>
          </div>
        )}
        <div>
          <p>{description}</p>
        </div>
      </header>
      {["dashboard"].includes(from) && (
        <section className="center_perfect gap_20 h_full">
          {page === "packages" && (
            <Tabs
              actived_tab={actived_tab}
              menu_tabs={menu_tabs}
              handle_tab={handle_tab}
            />
          )}
        </section>
      )}

      <footer style={{ minHeight: "300px" }}>{content}</footer>
    </main>
  );

  const modal_payment_universal_content = modal_payment_universal &&
    (user?.is_email_confirm !== "not_propose" ||
      user?.is_whatsapp_confirm !== "not_propose") &&
    !path_wo_payment_popup.includes(location.pathname) && (
      <Modal
        modalSize="large"
        id="modal"
        isOpen={modal_payment_universal}
        onClose={toggle_payment_universal}
        title={title}
      >
        <div className="box-body flex flex_col gap_10 h_full">
          {inside_content}
        </div>
      </Modal>
    );

  return <>{modal_payment_universal_content}</>;
};

export default Pricing;
